import React, { useState } from 'react'
import PropTypes from 'prop-types'
import LazyLoad from 'react-lazyload'
import { Modal } from 'react-responsive-modal'
import { PATHS } from '../../utils/vars'
import leftArrow from '../../assets/left-arrow.svg'
import rightArrow from '../../assets/right-arrow.svg'
import close from '../../assets/detailed-close.svg'

import styles from './PaintingDetailed.module.scss'

const PaintingDetailed = ({
    paintings, title, credit, desc, store, showContactForm,
}) => {
    const [detailed, setDetailed] = useState(false)
    const [activePainting, setActivePainting] = useState(1)

    const onCloseModal = () => {
        setDetailed(false)
    }

    return (
        <>
            {detailed && (
                <div className={styles.modal}>
                    <Modal
                        open={detailed}
                        onClose={() => onCloseModal()}
                        classNames={{
                            overlay: 'customOverlay',
                            modal: 'customModal',
                        }}
                    >
                        <div className="modalDetails">
                            <div className="painting">
                                <img alt="Current Painting" src={paintings[activePainting - 1]} className="image" />
                            </div>
                            <div className="details">
                                <p className="credit">{credit}</p>
                                <p className="txt">{title}</p>
                                <p className="txt">{desc}</p>
                                <button
                                    type="button"
                                    className="inquireBtn btn"
                                    onClick={() => {
                                        setDetailed(false)
                                        showContactForm()
                                    }}
                                >
                                    Learn more
                                </button>
                                <div className="actionPanel">
                                    <div className="pagination">
                                        <button type="button" className="btnPg" onClick={() => setActivePainting((idx) => (idx === 1 ? paintings.length : idx - 1))}>
                                            <img alt="Previous painting" src={leftArrow} />
                                        </button>
                                        <p className="txt">{`${activePainting}/${paintings.length}`}</p>
                                        <button type="button" className="btnPg" onClick={() => setActivePainting((idx) => (idx === paintings.length ? 1 : idx + 1))}>
                                            <img alt="Next painting" src={rightArrow} />
                                        </button>
                                    </div>
                                    <button
                                        type="button"
                                        className="btnPg"
                                        onClick={() => setDetailed(false)}
                                    >
                                        <img alt="Close" src={close} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
            )}

            <div className={`${styles.paintingContainer} colHalfLg`}>
                <div
                    className={`${styles.paintingDetailed} ${styles.slideUp} slide-up`}
                    role="button"
                    tabIndex={0}
                    onClick={() => setDetailed(true)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            setDetailed(true)
                        }
                    }}
                >
                    <LazyLoad height="100%" offset={500} once classNamePrefix="details">
                        <img alt={`${title}, ${credit}, ${desc}`} className="" src={paintings[0]} />
                    </LazyLoad>
                    <div className={`${styles.details} row`}>
                        <div className={`${styles.txt} colThreeQuartersMd`}>
                            <p className={styles.title}>{credit}</p>
                            <p className={styles.credit}>{title}</p>
                            <p className={styles.desc}>{desc}</p>
                        </div>
                        <div className={`colQuarterMd ${styles.btnDisplay}`}>
                            {
                                store ? (
                                    <button type="button" className={`btn ${styles.btn}`}>
                                        <a
                                            href={PATHS.STORE}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            visit the store
                                        </a>
                                    </button>
                                ) : <button type="button" className={`btn ${styles.btn}`}>Learn more</button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

PaintingDetailed.defaultProps = {
    store: false,
}

PaintingDetailed.propTypes = {
    paintings: PropTypes.arrayOf(PropTypes.string).isRequired,
    title: PropTypes.string.isRequired,
    credit: PropTypes.string.isRequired,
    desc: PropTypes.string.isRequired,
    store: PropTypes.bool,
    showContactForm: PropTypes.func.isRequired,
}

export default PaintingDetailed
